import classnames from 'classnames';
import React, { ReactElement } from 'react';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import styles from './layout.module.scss';
import { FreeTopBanner } from '../FreeTopBanner/FreeTopBanner';
import { useFreeUser } from 'v2/hooks/useFreeUser';

interface LayoutProps {
  children: ReactElement;
}

const Layout = ({ children }: LayoutProps) => {
  const [isFreeUser] = useFreeUser();
  return (
    <>
      <div className={classnames('d-flex', 'flex-column', styles.root)}>
        <div className="fixed-top">
          <FreeTopBanner />
          <Navbar />
        </div>
        <div
          className={classnames('w-100', styles.childContainer)}
          style={{ marginTop: isFreeUser ? '133px' : '92px' }}
        >
          <div className={classnames(styles.content)}>{children}</div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
